import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUpdateStatus = createSelector(
  [(store: RootState) => store.userAuthentication.updateStatus],
  (updateStatus) => updateStatus
);
